import { render, staticRenderFns } from "./BindsWave.vue?vue&type=template&id=7a84299d&"
import script from "./BindsWave.vue?vue&type=script&lang=js&"
export * from "./BindsWave.vue?vue&type=script&lang=js&"
import style0 from "./BindsWave.vue?vue&type=style&index=0&id=7a84299d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports